import React, { useState, startTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SettingOutlined,
  HomeFilled,
  ControlFilled,
  VideoCameraFilled,
  PlusCircleFilled,
  PlaySquareFilled,
  CalendarFilled,
} from '@ant-design/icons';
import { BsFillPeopleFill } from 'react-icons/bs';
import { FaBook, FaUser } from 'react-icons/fa';
import { BsCollectionPlayFill } from 'react-icons/bs';
import { Layout, Menu } from 'antd';
import './SideBar.css';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';
import { SlFeed } from 'react-icons/sl';
import { RiStockFill } from 'react-icons/ri';
import { FaHashtag } from 'react-icons/fa';
import { MdArticle } from 'react-icons/md';
import { CgMediaLive } from 'react-icons/cg';
import { RiShakeHandsFill } from 'react-icons/ri';

const { Sider } = Layout;

function Sidebar() {
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState('/');

  const handleMenuClick = (key) => {
    setSelectedKey(key);
    startTransition(() => {
      navigate(key);
    });
  };

  const { isAuthenticated, rl } = useSelector((state) => state.auth); // get role and isAuthenticated from redux state
  const decryptRole = decryptData(rl); // decrypt role

  const menuItems = [
    {
      key: '/',
      icon: <HomeFilled />,
      label: 'Home',
    },
    {
      key: '/session/all',
      icon: <VideoCameraFilled />,
      label: 'Sessions',
    },
    {
      key: '/event/calendar',
      icon: <CalendarFilled />,
      label: 'Event Calendar',
    },
    {
      key: 'education/meterial',
      icon: <FaBook />,
      label: 'Education Material',
    },
    {
      // key: '/analysis/market-analysis',
      icon: <BsFillPeopleFill />,
      label: 'Market Analysis',
      children: [
        {
          key: '/analysis/market-analysis',
          icon: <SlFeed />,
          label: 'Analysis',
        },
        {
          key: '/analysis/trading-signal',
          icon: <RiStockFill />,
          label: 'Trading Signal',
        },
      ],
    },

    {
      icon: <RiShakeHandsFill />,
      label: 'Community',
      children: [
        {
          key: '/community/feed',
          icon: <SlFeed />,
          label: 'Feed',
        },
        {
          key: '/community/topics',
          icon: <FaHashtag />,
          label: 'Topic',
        },
        {
          key: '/community/articles',
          icon: <MdArticle />,
          label: 'Articles',
        },
        {
          key: '/community/live',
          icon: <CgMediaLive />,
          label: 'Live',
        },
      ],
    },
  ];

  // Common items for both admin and editor roles
  if (
    isAuthenticated &&
    (decryptRole === 'admin' || decryptRole === 'editor')
  ) {
    const marketAnalysisItems = {
      icon: <BsCollectionPlayFill />,
      label: 'Market Analysis',
      children: [
        {
          key: 'admin/market-analysis/all',
          icon: <PlaySquareFilled />,
          label: 'All',
        },
        {
          key: 'admin/market-analysis/add',
          icon: <PlaySquareFilled />,
          label: 'Add',
        },
      ],
    };

    menuItems.push(marketAnalysisItems);

    // Additional items only accessible to admin
    if (decryptRole === 'admin') {
      menuItems.push({
        icon: <ControlFilled />,
        label: 'Admin Dashboard',
        children: [
          {
            key: 'admin/users/all',
            icon: <FaUser />,
            label: 'Users',
          },
          {
            icon: <VideoCameraFilled />,
            label: 'Sessions',
            children: [
              {
                key: 'admin/session/all',
                icon: <PlaySquareFilled />,
                label: 'All',
              },
              {
                key: 'admin/session/add',
                icon: <PlusCircleFilled />,
                label: 'Add',
              },
            ],
          },
          {
            icon: <BsCollectionPlayFill />,
            label: 'Collections',
            children: [
              {
                key: 'admin/collection/all',
                icon: <PlaySquareFilled />,
                label: 'All',
              },
            ],
          },
        ],
      });
    }
  }

  return (
    <>
      <Sider
        className="sider"
        width={250}
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          height: '100vh',
          backgroundColor: 'var(--background-secondary-color)',
          overflowY: 'auto',
          color: 'black',
        }}
      >
        <div className="logo-container">
          <img src="/img/logo.png" className="mt-[-20px]" alt="Logo" />
        </div>

        <div className="line-divider mt-[-20px]" />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={({ key }) => handleMenuClick(key)}
          className="menu"
          items={menuItems}
        />
      </Sider>
    </>
  );
}

export default Sidebar;
